import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  // filters 
  dateFrom: dayjs().startOf("month").toISOString(),
  dateTo: dayjs().endOf("month").toISOString(),

  rows: [],
  selectedIds: [],
  materialTransferCache: {},
  quickFilter: "",
};

const materialTransferSlice = createSlice({
  name: "materialTransfer",
  initialState,
  reducers: {
    setDateFrom: {
      reducer: (state, action) => {
        state.fromDate = action.payload;
      },
      prepare: (value) => ({
        payload:
          typeof value === "string"
            ? value
            : value?.toISOString?.() ?? null,
      }),
    },

    setDateTo: {
      reducer: (state, action) => {
        state.dateTo = action.payload;
      },
      prepare: (value) => ({
        payload:
          typeof value === "string"
            ? value
            : value?.toISOString?.() ?? null,
      }),
    },

    setRows: (state, action) => {
      state.rows = Array.isArray(action.payload) ? action.payload : [];
    },

    removeRowsByIds: (state, action) => {
      const ids = new Set(action.payload || []);
      state.rows = state.rows.filter((r) => !ids.has(r.id));
      state.selectedIds = [];
    },

    setSelectedIds: (state, action) => {
      state.selectedIds = action.payload || [];
    },

    setQuickFilter: (state, action) => {
      state.quickFilter = action.payload ?? "";
    },

    saveMaterialTransferToCache: (state, action) => {
      const { key, data } = action.payload;
      state.materialTransferCache[key] = data;
    },

    resetList: () => initialState,
  },
});

export const {
  setDateFrom,
  setDateTo,
  saveMaterialTransferToCache,
  removeRowsByIds,
  setSelectedIds,
  setQuickFilter,
  resetList,
} = materialTransferSlice.actions;

export default materialTransferSlice.reducer;
